import { cn } from "@/lib/utils";

interface GalleryPaginationProps {
  total: number;
  activeIndex: number;
  onSelect: (index: number) => void;
  dotActiveClass?: string;
  dotInactiveClass?: string;
  className?: string;
}

export function GalleryPagination({
  total,
  activeIndex,
  onSelect,
  dotActiveClass = "bg-foreground",
  dotInactiveClass = "border-foreground/40 bg-transparent",
  className,
}: GalleryPaginationProps) {
  if (total <= 1) {
    return null;
  }

  return (
    <div
      className={cn("flex items-center justify-center", className)}
      role="tablist"
      aria-label="Слайды галереи"
    >
      <div className="flex h-2 items-center gap-4">
        {Array.from({ length: total }, (_, index) => (
          <button
            key={index}
            type="button"
            role="tab"
            aria-selected={index === activeIndex}
            aria-label={`Слайд ${index + 1}`}
            onClick={() => onSelect(index)}
            className={cn(
              "size-2 rounded-full border transition-colors",
              index === activeIndex ? dotActiveClass : dotInactiveClass,
              index !== activeIndex && "hover:opacity-70"
            )}
          />
        ))}
      </div>
    </div>
  );
}
